import React from "react";
import {
  Typography,
  Card,
  Table,
  Tag,
  Button,
  Popconfirm,
  Row,
  Col,
  Breadcrumb,message,
} from "antd";
import { MoneyCollectOutlined } from "@ant-design/icons";
import { useGetWalletTransactionQuery } from "../../slices/paymentApiSlice";
import { useApproveTransactionMutation } from "../../slices/adminApiSlice";
import { useSelector } from "react-redux";
const { Title } = Typography;

const AdminWalletHistoryPage = () => {
      const { darkmode } = useSelector((state) => state.darkmode);
  
  const { data, isLoading } = useGetWalletTransactionQuery();
  const [approveTransaction] = useApproveTransactionMutation();
console.log(data);

const approveHandler = async (id) => {
  try {
    await approveTransaction(id).unwrap();
    message.success("Transaction Approved Successfully");
  } catch (err) {
    message.error(err?.data?.error || "Approval failed");
  }
};
const columns = [
  {
    title: "User ID",
    dataIndex: "userId",
  },
  {
    title: "Holder Name",
    render: (_, record) =>
      record.bankDetails?.holderName || "-",
  },
  {
    title: "Account No",
    render: (_, record) =>
      record.bankDetails?.accountNumber
        ? "XXXXXX" + record.bankDetails.accountNumber.slice(-4)
        : "-",
  },
  {
    title: "IFSC",
    render: (_, record) =>
      record.bankDetails?.ifsc || "-",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: (type) =>
      type === "credit" ? (
        <Tag color="green">CREDIT</Tag>
      ) : (
        <Tag color="red">DEBIT</Tag>
      ),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (amount) => `₹ ${amount}`,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (status) => {
      if (status === "pending")
        return <Tag color="orange">PENDING</Tag>;
      if (status === "approved")
        return <Tag color="green">APPROVED</Tag>;
      return <Tag color="red">REJECTED</Tag>;
    },
  },
  {
    title: "Date",
    dataIndex: "createdAt",
    render: (date) => new Date(date).toLocaleString(),
  },
  {
    title: "Action",
    render: (_, record) =>
      record.status === "pending" ? (
        <Popconfirm
          title="Approve this transaction?"
          onConfirm={() => approveHandler(record._id)}
        >
          <Button type="primary" size="small">
            Approve
          </Button>
        </Popconfirm>
      ) : (
        "-"
      ),
  },
];
  return (
    <div>
      {/* Page Title */}
      <Title
        level={2}
        style={{
          fontFamily: "Inter, sans-serif",
          marginBottom: "16px",
        }}
      >
        <MoneyCollectOutlined /> &nbsp; Wallet Transactions
      </Title>

      {/* Breadcrumb Section */}
     
      
          <Row
            style={{
              padding: "20px",
              backgroundColor: darkmode ? "#141414" : "#FFF",
              borderRadius: "5px",
              marginBottom: "20px", // Added spacing below breadcrumb row
            }}
          >
            <Col flex="auto">
              <Breadcrumb
   items={[
              { title: "Payment" },
              { title: "Wallet Transactions" },
            ]}                style={{ marginBottom: "5px" }}
              />
            </Col>
          </Row>

      {/* Table Section */}
      <Card title="All Wallet Transactions" loading={isLoading}>
        <Table
          columns={columns}
          dataSource={data?.data || []}
          rowKey={(record) => record._id}
          pagination={{ pageSize: 10 }}
          size="small"
          style={{ width: "100%" }}
          scroll={{ x: "max-content" }}
        />
      </Card>
    </div>
  );
};

export default AdminWalletHistoryPage;